<template>
  <el-container style="width:100%;">
    <el-main>
      <el-table :data="wallatHistoryData" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="listLoading">
        <el-table-column prop="created_at" :label="generateCustomizeString('time')">
          <template slot-scope="scope">{{ scope.row.created_at | toLocalTime}}</template>
        </el-table-column>
        <el-table-column prop="transaction_no" :label="generateCustomizeString('transactionNo')">
        </el-table-column>
        <el-table-column prop="source_name" :label="generateCustomizeString('operationType')" >
        </el-table-column>
        <el-table-column :label="generateCustomizeString('amount')">
          <template slot-scope="scope">
            <span v-if="scope.row.source_name === '订单'">+</span>
            <span v-else>-</span>
            <span>{{scope.row.amount | formatPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('balance')">
          <template slot-scope="scope">
            <span>{{scope.row.balance | formatPrice }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'walletHistory',
  data() {
    return {
      wallatHistoryData: [],
      currentPage: 0,
      currentTotal: 0,
      listLoading: false,
      pageSize: 15
    }
  },
  methods: {
    generateCustomizeString,
    handleCurrentChange(val) {
      this.fetchWalletHistory(val)
    },
    fetchWalletHistory(page) {
      if (this.listLoading) return
      this.listLoading = true
      request({
        url: 'agent/wallet/transactions',
        method: 'get',
        params: {
          shop_id: this.$route.params.agentId,
          page: page,
          page_size: this.pageSize
        }
      }).then(res => {
        if (res.status === 0) {
          const data = res.data
          const meta = res.meta
          const tmpData = data.map(obj => {
            // obj.created_at = obj.created_at.replace(/-/g, '/')
            // obj.created_at = dayjs(new Date(obj.created_at + ' UTC')).format('YYYY-M-D HH:mm:ss')
            return obj
          })
          this.wallatHistoryData = tmpData
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        }
      }).finally(() => {
        this.listLoading = false
      })
    }
  },
  created() {
    this.fetchWalletHistory(this.currentPage)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
